import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";

export default function Login() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            await login(email, password);
            navigate("/");
        } catch (err) {
            setError(formatApiError(err, "Inloggningen misslyckades"));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen canvas-bg flex items-center justify-center px-4" data-testid="login-page">
            <div className="w-full max-w-sm">
                <div className="glass-panel rounded-2xl p-8 shadow-2xl">
                    <div className="flex items-center gap-3 mb-2">
                        <img src="/hamn-emblem.png" alt="HAMN" data-testid="login-logo"
                            className="w-11 h-11 rounded-full border border-current/40 object-cover" />
                        <div>
                            <h1 className="font-display font-extrabold text-2xl tracking-tight text-slate-100">HAMN ATLAS</h1>
                            <p className="font-mono text-[10px] uppercase tracking-widest text-slate-500">Konsultvy · enanvändare</p>
                        </div>
                    </div>
                    <p className="text-sm text-slate-400 mb-6 mt-4">Kartlägg verksamheten. Hitta dammarna.</p>
                    <form onSubmit={submit} className="space-y-4">
                        <div>
                            <label className="font-mono text-[10px] uppercase tracking-widest text-slate-500 block mb-1.5">E-post</label>
                            <input
                                data-testid="login-email-input"
                                type="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="w-full bg-abyss/60 border border-border rounded-lg px-3 py-2.5 text-sm text-slate-100 outline-none focus:border-current/60 transition-colors"
                                placeholder="namn@exempel.se"
                            />
                        </div>
                        <div>
                            <label className="font-mono text-[10px] uppercase tracking-widest text-slate-500 block mb-1.5">Lösenord</label>
                            <input
                                data-testid="login-password-input"
                                type="password"
                                required
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="w-full bg-abyss/60 border border-border rounded-lg px-3 py-2.5 text-sm text-slate-100 outline-none focus:border-current/60 transition-colors"
                                placeholder="••••••••"
                            />
                        </div>
                        {error && (
                            <p data-testid="login-error" className="text-sm text-red-400 bg-red-500/10 border border-red-500/30 rounded-lg px-3 py-2">{error}</p>
                        )}
                        <button
                            data-testid="login-submit-button"
                            type="submit"
                            disabled={loading}
                            className="w-full bg-current text-abyss font-semibold text-sm rounded-lg py-2.5 hover:bg-tide transition-colors disabled:opacity-50 flex items-center justify-center gap-2"
                        >
                            {loading && <Loader2 className="w-4 h-4 animate-spin" />}
                            Logga in
                        </button>
                    </form>
                </div>
                <p className="text-center font-mono text-[10px] uppercase tracking-widest text-slate-600 mt-6">
                    GDPR · pseudonymiserat · audit-loggat
                </p>
            </div>
        </div>
    );
}
